<div class="user-panel">
    <!-- Modal Header - only shown when displayed as modal -->
    <div *ngIf="isModal" class="modal-header">
        <div class="modal-title">
            <span class="material-symbols-rounded" aria-hidden="true">person</span>
            <h4>{{ editUser ? editUser.firstName + ' ' + editUser.lastName : ('MENU.USER' | translate) }}</h4>
        </div>
        <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close">
            <span class="material-symbols-rounded" aria-hidden="true">close</span>
        </button>
    </div>

    <!-- Readonly Mode -->
    <div *ngIf="!isEditMode" class="readonly-view">
        <div class="panel-content">
            <div class="header" *ngIf="!isModal">
                <h3>{{ editUser?.firstName || '-' }} {{ editUser?.lastName || '-' }}</h3>
            </div>

            <div class="box">
                <div class="title">
                    <span class="material-symbols-rounded leading" aria-hidden="true">badge</span>
                    <h5>{{ 'FEATURES.USER.CONTACT_INFORMATION' | translate }}</h5>
                </div>
                <p>{{ editUser?.firstName || '-' }} {{ editUser?.lastName || '-' }}</p>
                <p *ngIf="editUser?.email">
                    <a [href]="'mailto:' + editUser.email">{{ editUser.email }}</a>
                </p>
                <p *ngIf="editUser?.phone">
                    <a [href]="'tel:' + editUser.phone">
                        {{ editUser.phone }}
                    </a>
                </p>
            </div>

            <div class="box">
                <div class="title">
                    <span class="material-symbols-rounded" aria-hidden="true">assignment_ind</span>
                    <h5>{{ 'FEATURES.USER.ROLES' | translate }}</h5>
                </div>
                <p>{{ editUser?.roles | roles }}</p>
            </div>

            <div class="form-actions">
                <button type="button" (click)="enterEditMode()">
                    {{ 'BUTTONS.EDIT' | translate }}
                </button>
            </div>
        </div>
    </div>

    <!-- Edit Mode -->
    <div *ngIf="isEditMode" class="edit-view">
        <form [formGroup]="userForm" (ngSubmit)="saveAndExitEdit()" autocomplete="off">
            <div class="panel-content" [class.loading]="loading">
                <app-form-section>
                    <app-form-row>
                        <app-form-group>
                            <label for="firstName">{{ 'FEATURES.USER.FIRST_NAME' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="firstName"
                                formControlName="firstName"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.firstName"
                                languageKey="FEATURES.USER.FIRST_NAME"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="lastName">{{ 'FEATURES.USER.LAST_NAME' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="lastName"
                                formControlName="lastName"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.lastName"
                                languageKey="FEATURES.USER.LAST_NAME"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="email">{{ 'FEATURES.USER.EMAIL' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="email"
                                formControlName="email"
                                type="email"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.email"
                                languageKey="FEATURES.USER.EMAIL"
                            />
                        </app-form-group>
                    </app-form-row>

                    <app-form-row>
                        <app-form-group>
                            <label for="phone">{{ 'FEATURES.USER.PHONE' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="phone"
                                formControlName="phone"
                                type="text"
                                [placeholder]=""
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="password"
                                >{{ 'FEATURES.USER.PASSWORD' | translate
                                }}<ng-container *ngIf="editUser">
                                    ({{ 'TEXTS.OPTIONAL' | translate }})</ng-container
                                ></label
                            >
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="password"
                                formControlName="password"
                                type="password"
                                [placeholder]=""
                                autocomplete="new-password"
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.password"
                                languageKey="FEATURES.USER.PASSWORD"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="confirmPassword"
                                >{{ 'FEATURES.USER.CONFIRM_PASSWORD' | translate
                                }}<ng-container *ngIf="editUser">
                                    ({{ 'TEXTS.OPTIONAL' | translate }})</ng-container
                                ></label
                            >
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="confirmPassword"
                                formControlName="confirmPassword"
                                type="password"
                                [placeholder]=""
                                autocomplete="new-password"
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.confirmPassword"
                                languageKey="FEATURES.USER.CONFIRM_PASSWORD"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row *ngIf="newUser">
                        <app-form-group>
                            <app-checkbox
                                id="createPrivateTenant"
                                formControlName="createPrivateTenant"
                                [text]="'FEATURES.USER.CREATE_PRIVATE_TENANT' | translate"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row *ngIf="createUnrestrictedUser">
                        <app-form-group>
                            <app-checkbox
                                id="showRoles"
                                [text]="'FEATURES.USER.CREATE_UNRESTRICTED_USER' | translate"
                                (change)="toggleShowRoles()"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row *ngIf="showRoles">
                        <app-form-group>
                            <label for="roles">{{ 'FEATURES.USER.ROLES' | translate }}</label>
                            <app-select-roles id="roles" formControlName="roles" />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.roles"
                                languageKey="FEATURES.USER.ROLES"
                            />
                        </app-form-group>
                    </app-form-row>
                </app-form-section>

                <div class="form-actions">
                    <button type="button" (click)="cancelEdit()">
                        {{ 'BUTTONS.CANCEL' | translate }}
                    </button>
                    <button type="submit" class="primary" [class.loading]="loading" [disabled]="isDisabled()">
                        {{ 'BUTTONS.SAVE' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
